<template>
  <div id="wrapper">
    <JournalHeader
        v-if="page"
        :mediaLogo="page.mediaLogo"
        :mediaName="page.media"
        :journalType="page.journalType"
        :publishDate="page.publishDate"
        :keywords="keywords"
    />
    <v-card v-if="page" class="card-main-page mt-2">
      <v-card-title class="pa-1">
        <span class="ml-3 body-2 primary--text">{{ page.pageNo | pageNoText }}</span>
        <v-spacer/>
        <v-btn 
          flat 
          @click="continueClipping"
          :class="{ hidden: !pending }"
        >Clipping</v-btn>
      </v-card-title>
      <v-divider></v-divider>
      <v-card-text class="pa-0">
        <ScreenshotWrapper
          v-if="image.width && image.height"
          :width="image.width"
          :height="image.height"
          :disabled="disableScreenshot"
          @image-cropped="createReport"
          @took-screenshot="progress = true"
        >
          <page :item="page" />
        </ScreenshotWrapper>
      </v-card-text>
    </v-card>
    <v-dialog v-model="clipFormDialog" width="800" persistent>
      <ClipForm 
        :croppedImage="croppedImage"
        :reports="reports"
        :page="page"
        :download="false"
        :minimizable="true"
        @save="save"
        @cancel="cancel"
        @minimize="minimizeClipping"
      />
    </v-dialog>
    <v-dialog v-model="progress" width="200" persistent>
      <v-card>
        <v-card-text class="text-xs-center">
          <v-progress-circular
            indeterminate
            color="primary"
          ></v-progress-circular>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-snackbar
      v-model="showCompleteMsg"
      top
      color="success"
    >
      Report Saved Successfully!
    </v-snackbar>
  </div>
</template>

<script>
import Page from '@/components/Page';
import ScreenshotWrapper from "@/components/ScreenshotWrapper";
import ClipForm from "@/components/ClipForm";
import { mapActions, mapState, mapMutations } from "vuex";
import JournalHeader from "@/components/JournalHeader";
import page from "@/mixins/page";
import current_user from '@/mixins/current_user';

export default {
  components: {
    Page,
    ScreenshotWrapper,
    ClipForm,
    JournalHeader,
  },

  mixins: [ page, current_user ],

  data() {
    return {
      clipFormDialog: false,

      croppedImage: {
        url: undefined,
        blob: undefined,
      },

      disableScreenshot: false,

      image: {
        width: undefined,
        height: undefined,
      },

      progress: false,

      showCompleteMsg: false,

      pending: false,
    };
  },

  created() {
    // fetch page info and word vectors
    this.setPageLoading(true);
    this.fetchPage({ pageId:  this.pageID, keywords: this.keywords})
      .then(() => {
        this.setPageLoading(false);

        this.image.width = document.querySelector("#wrapper").clientWidth;
        this.image.height = this.image.width * 1.257;
      });

    this.fetchReports();
  },

  methods: {
    ...mapActions('clipping', [
      'fetchPage',
      'uploadScreenshot',
    ]),

    ...mapActions('clips', [
      'saveClip'
    ]),

    ...mapMutations('clipping', [
      'setPageLoading',
    ]),

    ...mapActions('reports', [
      'fetchReports',
    ]),

    createReport(canvas) {
      this.croppedImage.url = canvas.toDataURL("image/png");
      canvas.toBlob(blob => {
        this.croppedImage.blob = blob;
      }, "image/png");
      this.progress = false;

      this.clipFormDialog = true;
      this.disableScreenshot = true;
    },

    cancel() {
      this.clipFormDialog = false;
      this.disableScreenshot = false;
      this.croppedImage = Object.assign({}, { url: undefined, blob: undefined });
    },

    async save(clip) {
      // save screenshot
      const formData = new FormData();
      formData.append("screenshot", this.croppedImage.blob);
      const { data } = await this.uploadScreenshot(formData);

      // save clip
      const payload = Object.assign({}, clip, {
        pageID: this.page.pageId,
        screenshot: data.url,
        keywords: [ ...this.page.keywords ],
      });
      this.saveClip(payload).then(() => {
        this.clipFormDialog = false;
        this.disableScreenshot = false;
        this.croppedImage = Object.assign({}, { url: undefined, blob: undefined });
        this.showCompleteMsg = true;
      });
      this.$ua.trackEvent('CreateClip', 'click',
        `${this.currentUser.username || 'User'} created ${JSON.stringify(payload, null, 2)}`);
    },

    minimizeClipping() {
      this.clipFormDialog = false;
      this.pending = true;
    },

    continueClipping() {
      this.clipFormDialog = true;
      this.pending = false;
    },
  },

  computed: {
    ...mapState('clipping', [
      'page',
      'pageLoading',
    ]),

    ...mapState('reports', [
      'reports'
    ]),

    pageID() {
      return this.$route.params.id;
    },

    keywords() {
      let { keywords } = this.$route.query;
      keywords = keywords ? keywords : [];
      keywords = Array.isArray(keywords) ? [...keywords] : [keywords];
      return keywords;
    },
  },
}
</script>

<style scoped>
.hidden {
  visibility: hidden;
}
</style>